const camera_settings_schema = [
	{ name: 'brightness', type: 'number', kind: 'range', row: 0 },
	{ name: 'contrast', type: 'number', kind: 'range', row: 0 },
	{ name: 'exposureMode' },
	{
		name: 'exposureTime',
		label: 'Exposure',
		parent: 'exposureMode',
		type: 'number',
		kind: 'range',
		formatter: 'integer',
		row: 1,
	},
	{
		name: 'exposureCompensation',
		label: 'Compensation',
		parent: 'exposureMode',
		type: 'number',
		step: 1,
		natural_step: 10,
		kind: 'range',
		row: 1,
	},
	{ name: 'whiteBalanceMode' },
	{
		name: 'colorTemperature',
		label: 'Color temp',
		parent: 'whiteBalanceMode',
		type: 'number',
		kind: 'range',
		natural_step: 50,
		row: 2,
	},
	{ name: 'saturation', type: 'number', kind: 'range', row: 2 },
	{ name: 'focusMode' },
	{ name: 'focusDistance', label: 'Focus', parent: 'focusMode', type: 'number', kind: 'range', row: 3 },
	{ name: 'sharpness', type: 'number', kind: 'range', row: 3 },
]

export default camera_settings_schema
